document.addEventListener("DOMContentLoaded", () => {
    if (window.location.pathname === '/account/login') {  
       let interval = setInterval(() => {
         const loginLinks = document.querySelector("a.account--login");
            if(loginLinks && loginLinks.getAttribute('href') === '/account/register'){
                clearInterval(interval);
                loginLinks.setAttribute("href",'/pages/sign-up-an-account') 
            }
        }, 50);

        setTimeout(() => {
            clearInterval(interval);
        }, 1000);
    }
});